import { Configurator } from '@Config/Config';
import { Features } from '@Config/Features';

export function toggleFeature(name: Features): boolean {
  const features: Record<string, boolean> = Configurator.get('features');

  features[name] = !features[name];

  Configurator.set('features', features);

  return true;
}

export function persistFeaturesForDev(): void {
  const features: Record<string, boolean> = Configurator.get('features');

  localStorage.setItem('features', JSON.stringify(features));
}

export function getFeaturesFromDev(): Record<string, any> | undefined {
  const featuresRaw = localStorage.getItem('features');
  if (featuresRaw !== null) {
    return JSON.parse(featuresRaw);
  }

  return undefined;
}

export function clearFeaturesFromDev(): void {
  localStorage.removeItem('features');
}

export function refreshFeaturesForDev(): void {
  const features = getFeaturesFromDev();
  const featuresCurrent: Record<string, boolean> = Configurator.get('features');

  Configurator.set('features', {
    ...featuresCurrent,
    ...features
  });
}
